import React, { memo } from "react";
import Button from "react-bootstrap/Button";
import ActionPanel from "../../../../../components/action-panel-modal/action-panel";
import successIcon from "../../../../../assets/img/template-confirmation-icon.svg";
import { useHistory } from "react-router-dom";
import PropTypes from "prop-types";

const TemplateCreateEditConfirmationPanelNew = ({
  show,
  templateId,
  isEdit,
  canCreate,
  templateName,
}) => {
  let history = useHistory();

  const buttonTemplate = (
    <Button
      className="btn-wide"
      onClick={() => history.push("/admin?tab=templates")}
    >
      Go To Template List
    </Button>
  );

  const buttonTask = (
    <Button
      className="btn-outlined btn-wide"
      onClick={() =>
        history.push({
          pathname: "/admin/templates/tasks/create",
          state: { templateID: templateId, templateName: templateName },
        })
      }
    >
      Add Tasks
    </Button>
  );

  const mainText = (
    <div style={{ fontSize: "20px"}}>
      Project template has been created successfully.
    </div>
  );

  return (
    <ActionPanel
      show={show}
      onHide={() => history.goBack()}
      header={
        isEdit ? "Save Confirmation" : "Create Project Template Confirmation"
      }
      icon={successIcon}
      mainText={isEdit ? "Your changes have been saved" : mainText}
      acceptButton={isEdit ? buttonTemplate : buttonTask}
      rejectButton={isEdit ? (canCreate ? buttonTask : null) : buttonTemplate}
    />
  );
};

TemplateCreateEditConfirmationPanelNew.propTypes = {
  isEdit: PropTypes.bool,
  templateId: PropTypes.number,
  canCreate: PropTypes.bool,
  show: PropTypes.bool.isRequired,
  templateName: PropTypes.string.isRequired,
};
export default memo(TemplateCreateEditConfirmationPanelNew);
